// Les pages principales se trouvent désormais dans le dossier views
import ShowPlanning from '@/views/App/ShowPlanning.vue';
import ShowProjects from '@/views/App/ShowProjects.vue';
import ShowRessourceHuman from '@/views/App/ShowRessourceHuman.vue';
import ShowCash from '@/views/App/ShowCash.vue';
import ShowIdeas from '@/views/App/ShowIdeas.vue';
import ShowClients from '@/views/App/ShowClients.vue';
import ShowUsers from '@/views/App/ShowUsers.vue';
import LoginRegister from '@/views/Auth/LoginRegister.vue';

import ProjectDetails from '@/components/Projet/ProjectDetails/ProjectDetails.vue';
import ClientDetails from '@/components/Details/ClientDetails.vue';
import UserDetails from '@/components/Details/UserDetails.vue';

export const appRoutes = [
  { path: '/login', component: LoginRegister, name: 'login' },
  { path: '/planning', component: ShowPlanning, name: 'planning', meta: { requiresAuth: true } },
  { path: '/projects', component: ShowProjects, name: 'projects', meta: { requiresAuth: true } },
  { path: '/ressources', component: ShowRessourceHuman, name: 'ressources', meta: { requiresAuth: true } },
  { path: '/cash', component: ShowCash, name: 'cash', meta: { requiresAuth: true } },
  { path: '/ideas', component: ShowIdeas, name: 'ideas', meta: { requiresAuth: true } },
  { path: '/clients', component: ShowClients, name: 'clients', meta: { requiresAuth: true } },
  { path: '/users', component: ShowUsers, name: 'users', meta: { requiresAuth: true } },
  { path: '/project/:id', component: ProjectDetails, props: true, name: 'project-details', meta: { requiresAuth: true } },
  { path: '/client/:id', component: ClientDetails, props: true, name: 'client-details', meta: { requiresAuth: true } },
  { path: '/user/:id', component: UserDetails, props: true, name: 'user-details', meta: { requiresAuth: true } },
]
